import { permissionsEnumSchema } from "@mindlercare/schema";
import { theme as defaultTheme, Button } from "@mindlercare/ui-web";
import CONSTANTS from "core/constants";
import { hasPermissions } from "helpers/permissions";
import { useCurrentUser } from "hooks/userHooks";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes, useParams } from "react-router-dom";
import useMarketStrategy from "strategies/market/useMarketStrategy";
import { styled } from "styled-components";
import { useMindlerApi } from "api/apiv2";
import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import BackButton from "../../lib/backButton";
import { PatientCardTabs } from "./PatientCardTabs";
import { Bookings } from "./bookings";
import { Icbt } from "./icbt";
import PatientActions from "./patientActions";
import { PatientData } from "./patientData";
import { PatientDataModal } from "./patientData/patientDataModal";
import { PromoCodes } from "./promocodes";

export type PatientCardUrlParams = {
  psychologistId: string;
  patientUserId: string;
  tab: string;
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(p) => defaultTheme.MARGIN.XL};
  padding-top: ${(p) => defaultTheme.MARGIN.SM};
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
`;

export const PatientCard = () => {
  const { t } = useTranslation();
  const { user } = useCurrentUser();
  const { showEditPatientDetails } = useMarketStrategy();
  const hasEditPatientDetailsPermission = hasPermissions(
    user,
    permissionsEnumSchema.enum.USER_EDIT,
  );
  const [isModalOpen, setOpenModal] = useState(false);
  const { patientUserId } = useParams<PatientCardUrlParams>();

  const apiv2 = useMindlerApi();
  const { data: patient } = useQuery(
    apiv2.patients.getByUserId.queryOptions(
      {
        patientUserId: Number(patientUserId),
      },
      {
        enabled: !!patientUserId,
      },
    ),
  );

  return (
    <>
      <Root>
        <Header>
          <BackButton />
          {showEditPatientDetails && hasEditPatientDetailsPermission && (
            <Button onClick={() => setOpenModal(true)} variant="secondary">
              {t("PATIENT_EDIT_DETAILS")}
            </Button>
          )}
        </Header>
        <PatientData patientUserId={patientUserId} />

        <PatientCardTabs patientUserId={patientUserId} />

        <Routes>
          <Route
            path={`${CONSTANTS.PATIENT_CARD_TABS.BOOKINGS.toLowerCase()}`}
            element={
              patient ? <Bookings patientId={patient.patientId} /> : <></>
            }
          />
          <Route
            path={`${CONSTANTS.PATIENT_CARD_TABS.ICBT.toLowerCase()}`}
            element={<Icbt />}
          />
          <Route
            path={`${CONSTANTS.PATIENT_CARD_TABS.PROMOCODES.toLowerCase()}`}
            element={<PromoCodes patient={patient} />}
          />
          <Route
            path={`${CONSTANTS.PATIENT_CARD_TABS.ACTIONS.toLowerCase()}`}
            element={<PatientActions patient={patient} />}
          />
        </Routes>
      </Root>

      {patient && (
        <PatientDataModal
          open={isModalOpen}
          onClose={() => setOpenModal(false)}
          patient={patient}
        />
      )}
    </>
  );
};
